module.exports = __webpack_public_path__ + "static/media/Button.fc76f66c.svg";